// ---- The price list (CEO, 2026-11-03) ----
// Per billing currency. The usage endpoint reports what was actually counted;
// these are only for the price line on the page. The trial month (the first)
// waives the base fee only; overage and commission still apply.
export const PRICING = {
  HUF: { baseFee: 19990, includedViews: 500, perView: 15, overageCap: 60000, commissionRate: 0.05 },
  EUR: { baseFee: 49, includedViews: 500, perView: 0.04, overageCap: 150, commissionRate: 0.05 },
};

export function pricingFor(currency) {
  return PRICING[String(currency || '').toUpperCase()] || PRICING.HUF;
}

/// 'YYYY-MM' of a date (local calendar).
export function periodKey(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

/// The month picker's options: this month and the `count - 1` before it.
export function recentPeriods(count = 6, today = new Date()) {
  return Array.from({ length: count }, (_, i) => periodKey(new Date(today.getFullYear(), today.getMonth() - i, 1)));
}
